import { Helmet } from 'react-helmet-async';
import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import * as R from 'Router/routes';
import { Card, Link, Typography } from 'components';
import DesktopIcon from 'assets/icons/desktop.svg?react';
import styles from 'pages/Registration/ProofIncome/ProofIncome.module.scss';
import UploadDocuments from 'pages/Registration/ProofIncome/UploadDocuments/UploadDocuments';
import { useTranslation } from 'react-i18next';

const ProofIncome = memo(function ProofIncome() {
  const { t } = useTranslation('proof_income');
  const navigate = useNavigate();
  const handleSuccessfullySubmit = useCallback(async () => {
    navigate(R.WAITING);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <div>
        <Typography
          className={styles.title}
          kind="h1"
          size="xl"
          dataTest="proofIncome-title"
        >
          {t('title')}
        </Typography>
        <Typography
          size="s"
          className={styles.information}
          dataTest="proofIncome-info"
        >
          {t('information')}
        </Typography>
        <Typography
          size="s"
          fontWeight={700}
          className={styles.information2}
          dataTest="proofIncome-info_2"
        >
          {t('information_2')}
        </Typography>
      </div>

      <Card className={styles.card}>
        <div className={styles['card-title-wrapper']}>
          <DesktopIcon
            className={styles.desktop}
            data-test="proofIncome-desktop-icon"
          />
          <Typography size="m" dataTest="proofIncome-card-title">
            {t('card_title')}
          </Typography>
        </div>
        <UploadDocuments onSuccess={handleSuccessfullySubmit} />
      </Card>

      <div className={styles['box-wrapper']}>
        <div className={styles.link}>
          <Link to={R.DOCUMENT_UPLOAD_LATER} dataTest="proofIncome-link-name">
            {t('link_name')}
          </Link>
        </div>
      </div>
    </>
  );
});

export default ProofIncome;
